import TableRow from '../trow/trow.vue'
import groupTableTbody from './group-table-tbody'
export default {
  name: 'table-tbody',
  inject: {
    table: { default: () => ({}) }
  },
  props: ['fixed', 'columns', 'dHeight', 'height', 'width', 'columnManager'],
  data () {
    return {
      scrollTop: 0, // 具体顶部 top值
      originStartIdx: 0, //开始下标
      bufferSize: 3, // 防止白屏 buffer
      total: this.table?.dataSource?.length, // 总数据
      cachedPositions: [], // 缓存高度
      estimatedRowHeight: 70 // 预估 高度
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.$emit('saveRef', 'tableBody', this)
    },
    // 当前组，组下数据，组index
    renderRows (data, rows = []) {
      // 处理传入class style
      const { expandColumn, openVirtual } = this.table
      const { fixed, columns } = this
      let startIndex = openVirtual.table ? this.table.startIndex : 0
      let endIndex = openVirtual.table ? this.table.endIndex : data.length
      for (let i = startIndex; i < endIndex; i++) {
        const record = data[i]
        const rowProps = {
          props: {
            fixed,
            columns,
            rowIndex: i,
            row: record
          }
        }
        let row = <TableRow {...rowProps} />
        rows.push(row)
        if (expandColumn) {
          rows.push(
            this.renderExpand(expandColumn, record, i, columns.length)
          )
        }
      }
      return rows
    },   
    renderExpand (column, record, rowIndex, key, columnsCount) {
      const expandProps = {
        props: {
          column,
          fixed: column.fixed,
          row: record,
          key: `expanded-row-${key}`,
          columnsCount,
          rowIndex
        }
      }
      // console.log('expandProps', expandProps)
      return <div>Expand</div>
    },
    renderGroupRow (groups, columns) {
      const { fixed, startIndex, endIndex, groupKey } = this.table
      let rows = []
      // for (let i = startIndex; i < endIndex; i++) {
      for (let i = 0; i < groups.length; i++) {
        const group = groups[i]
        if (group[groupKey]) {
          rows.push(<groupTableTbody 
            key={group.key}
            fixed={fixed} 
            columns={columns} 
            width={this.width} 
            groupList={group[groupKey]} 
            groupInfo={group} 
            groupIndex={i}
          >
          </groupTableTbody>)
        }
      } 
      return rows
    }
  },
  render (h) {
    const { dataSource, prefix, isGroup } = this.table
    return (
      <div class={`${prefix}-tbody`}>
        {isGroup
          ? this.renderGroupRow(dataSource, this.columns)
          : this.renderRows(dataSource)}
      </div>
    )
  },
  components: {
    TableRow,
    groupTableTbody
  }
}
